module.exports = __webpack_public_path__ + "img/night-club.045d104b.svg";